import React from "react";
import PropTypes from "prop-types";
import ChimneyProfileWebsitesContainer from "./Containers/ChimneyProfileWebsitesContainer";
//import { Test } from './ProfileTopTen.styles';

function websiteHref(link) {
  const trimmed = String(link).trim();
  if (/^[a-z][a-z0-9+.-]*:/i.test(trimmed)) {
    return trimmed;
  }
  if (trimmed.startsWith("//")) {
    return `https:${trimmed}`;
  }
  return `https://${trimmed}`;
}

const ProfileWebsites = (props) => (
  <ChimneyProfileWebsitesContainer
    chimDir={props.chimDir}
    render={({ websites }) => (
      <div className="profile-right-nav profile-top-ten">
        <h3>Favorite Websites</h3>
        <ul className="list-flat">
          {websites.map((website, i) => (
            <li key={i}>
              <a href={websiteHref(website.link)} target="_blank" rel="noopener noreferrer">
                {website.link.length > 44 ? website.link.substr(0, 44) + "..." : website.link}
              </a>
            </li>
          ))}
        </ul>
      </div>
    )}
  />
);

ProfileWebsites.propTypes = {
  chimDir: PropTypes.string.isRequired,
};

export default ProfileWebsites;
